<template lang="pug">
  #topbar.header
    span.btn-link.toggle-sidebar.d-lg-none.pg.pg-menu(@click="toggleMenu")
      i.iconfont.icon-expand
    div.d-flex(v-if="routesPure.length")
      Breakcrumb(:routesPure='routesPure')
    div.d-flex(v-else)
      Logo
      .toolbar-version.d-sm-block {{version}}
    div.d-flex.align-items-center
      Setting(:realName='realName')
      Toolbar.d-lg-block
      Quickview
</template>

<script>
import { mapMutations } from 'vuex'

import { VERSION, SUBVERSION } from '@/utils/common'

import Logo from './Logo'
import Toolbar from './Toolbar'
import Setting from './Setting'
import Quickview from './Quickview'
import Breakcrumb from './Breakcrumb'

export default {
  name: 'topbar',
  components: {
    Logo,
    Toolbar,
    Setting,
    Quickview,
    Breakcrumb
  },
  props: {
    realName: String,
    routesPure: Array
  },
  data () {
    return {
      version: `V${VERSION}.${SUBVERSION}`
    }
  },
  methods: {
    ...mapMutations([
      'toggleMenu'
    ])
  }
}
</script>

<style lang="sass" scoped>
.toggle-sidebar
  cursor: pointer
.toolbar-version
  display: none
  padding-left: 20px
  line-height: 36px
.align-items-end
  align-items: end
</style>



// WEBPACK FOOTER //
// index.vue?0acd9b3c